import { ActionConfigDTO, FormRowConfigDTO, MaintainTabDTO, MenuDTO } from '../../../../system/system-dtos';
import { SpecificEndpointDataSource } from './data-source';
import { ExtractedActions } from '../../../../common/event-dtos';
import { MenuUtils } from '../../../../common/utils/menu-utils';

export class MaintainDataSource extends SpecificEndpointDataSource {
  public getTabs(menuConfig: MenuDTO): MaintainTabDTO[] {
    const firstMaintainConfig = MenuUtils.getFirstMaintainConfig(menuConfig.entityGroup);
    return firstMaintainConfig ? firstMaintainConfig.tabs : null;
  }

  public getRows(menuConfig: MenuDTO): FormRowConfigDTO[] {
    return MenuUtils.getFirstMaintainConfig(menuConfig.entityGroup).rows;
  }

  override getNoteForData(menu: MenuDTO): string {
    return 'All changes can be seen immediately after they take place on server side but view is not updated automatically. Refresh button is your friend.';
  }

  getOverallRestActions(menu: MenuDTO): ActionConfigDTO[] {
    const firstMaintainConfig = MenuUtils.getFirstMaintainConfig(menu.entityGroup);
    return firstMaintainConfig ? firstMaintainConfig.overallRestActions : [];
  }

  override extractActions(menuConfig: MenuDTO, tab: MaintainTabDTO, element: any): ExtractedActions {
    const parentActions = super.extractActions(menuConfig, tab, element);
    return {
      rest: MenuUtils.getFirstMaintainConfig(menuConfig.entityGroup).restActions,
      simple: parentActions.simple,
    };
  }
}
